import { Model } from '@vuex-orm/core'

export default class JobAttach extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'jobAttachs'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      job_id: this.attr(null),
      attach_media_id: this.attr(null),
      author_user_id: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/JobAttach.js